<div
  class="session-card bg-white p-5 w-100 max-350 border-radius-10 m-auto mrb-10 mrb-md-0 box-shadow"
>
  <div class="session-card-img position-relative hover-img text-center">
    <!-- <div class="offer-btn ptb-3 pse-5 border-radius-5 text-gray1 position-absolute">خصم 10%</div> -->
    <a [routerLink]="['/session/', productId]">
      <img
        class="w-100 max-300 height-350px border-radius-10"
        [src]="image"
        alt="card img"
        defaultImage
      />
    </a>
  </div>
  <div class="session-card-body pse-5">
    <a [routerLink]="['/session/', productId]">
      <div
        class="session-card-title weight-700 max-height-37 ptb-5 size-5 mrb-2"
      >
        {{ name }}
      </div>
    </a>
    <div class="price mrb-14">
      <div class="row">
        <!-- <div class="col-6 col-md-6 old-price size-5 weight-700">{{ salePrice }} ريال</div> -->
        <div class="col-6 col-md-6 old-price size-5 weight-700">
          {{ price }} {{ "session.currency" | translate }}
        </div>
      </div>
    </div>
    <a
      (click)="openFormDialog()"
      class="cursor-pointer session-card-btn mrtb-5 d-block bg-primary text-white text-center border-radius-5 ptb-5 weight-700"
    >
      {{ "bookNow" | translate }}
    </a>
  </div>
</div>
<!-- [routerLink]="['/session/book', productId]" -->
